import { render, staticRenderFns } from "./HomeProductBanner.vue?vue&type=template&id=dfe2fffc&scoped=true&"
import script from "./HomeProductBanner.vue?vue&type=script&lang=js&"
export * from "./HomeProductBanner.vue?vue&type=script&lang=js&"
import style0 from "./HomeProductBanner.vue?vue&type=style&index=0&id=dfe2fffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe2fffc",
  null
  
)

export default component.exports